<template>
    <BootstrapModal
      ref="modal"
      modalId="deletePhotoModal"
      title="Confirm Photo Deletion"
      closeText="No"
      confirmText="Yes, Delete"
      isDeleteConfirmation
      :deleteMessage="deleteMessage"
      @confirm="handleConfirm"
    />
  </template>
  
  <script>
  import BootstrapModal from "@/components/Common/BootstrapModal.vue";
  import photoService from "@/services/photoService.js";
  import emitter from "@/eventBus";
  
  export default {
    name: "DeletePhotoModal",
    components: { BootstrapModal },
    props: {
      photo: {
        type: Object,
        required: false,
        default: null,
      },
    },
    emits: ["deleted"],
    computed: {
      deleteMessage() {
        return this.photo
          ? `Are you sure you want to delete photo <b>#${this.photo.id} (${this.photo.unic_id})</b>?<br>
              <span class="text-secondary small">This action is irreversible.</span>`
          : "Are you sure you want to delete this photo?";
      },
    },
    methods: {
      show() {
        this.$refs.modal.show();
      },
      hide() {
        this.$refs.modal.hide();
      },
      async handleConfirm() {
        if (!this.photo?.id) return;
  
        try {
          await photoService.deletePhoto(this.photo.id);
          emitter.emit("show-toast", {
            message: `Photo #${this.photo.id} deleted successfully.`,
            type: "success",
          });
          this.$emit("deleted", this.photo.id);
        } catch (error) {
          console.error(error);
        }
  
        this.hide();
      },
    },
  };
  </script>
  